import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import {
  AppState,
  FilterState,
  LivingSpaceRange,
  PriceRange,
  PropertySpaceRange,
  RoomCountRange,
  UsageSpaceRange,
} from '@immosky/types';
import {
  selectFilterState,
  setLivingSpaceFilter,
  setPriceFilter,
  setPropertySpaceFilter,
  setRoomCountFilter,
  setUsageSpaceFilter,
} from '@immosky/object-search-filter';
import { select, Store } from '@ngrx/store';

@Component({
  selector: 'app-desktop-step-two',
  templateUrl: './desktop-step-two.component.html',
  styleUrls: ['./desktop-step-two.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DesktopStepTwoComponent {
  filterState!: FilterState;

  displayRoomCount = false;
  displayLivingSpace = false;
  displayUsageSpace = false;
  displayPropertySpace = false;

  constructor(
    private cdRef: ChangeDetectorRef,
    private store: Store<AppState>
  ) {
    this.store
      .pipe(select(selectFilterState))
      .subscribe((filterState: FilterState) => {
        this.filterState = filterState;

        this.displayRoomCount = filterState.roomCount.isDisplayed;
        this.displayLivingSpace = filterState.livingSpace.isDisplayed;
        this.displayUsageSpace = filterState.usageSpace.isDisplayed;
        this.displayPropertySpace = filterState.propertySpace.isDisplayed;

        this.cdRef.markForCheck();
      });
  }

  onPriceChange(filter: PriceRange) {
    this.store.dispatch(
      setPriceFilter({
        filter,
      })
    );
  }

  onRoomCountChange(filter: RoomCountRange) {
    this.store.dispatch(
      setRoomCountFilter({
        filter,
      })
    );
  }

  onLivingSpaceChange(filter: LivingSpaceRange) {
    this.store.dispatch(
      setLivingSpaceFilter({
        filter,
      })
    );
  }

  onUsageSpaceChange(filter: UsageSpaceRange) {
    this.store.dispatch(
      setUsageSpaceFilter({
        filter,
      })
    );
  }

  onPropertySpaceChange(filter: PropertySpaceRange) {
    this.store.dispatch(
      setPropertySpaceFilter({
        filter,
      })
    );
  }
}
